import {
  Bold,
  Code,
  Italic,
  List,
  ListChecks,
  ListOrdered,
  Quote,
  SquareCode,
  Strikethrough,
} from 'lucide-react';

import type { RichTextAction, RichTextBlockOption } from './types';

export const MARK_ACTIONS: RichTextAction[] = [
  {
    label: 'Bold',
    tip: 'Make text bold',
    shortcut: 'Ctrl+B',
    icon: Bold,
    isActive: (e) => e.isActive('bold'),
    run: (e) => e.chain().focus().toggleBold().run(),
  },
  {
    label: 'Italic',
    tip: 'Make text italic',
    shortcut: 'Ctrl+I',
    icon: Italic,
    isActive: (e) => e.isActive('italic'),
    run: (e) => e.chain().focus().toggleItalic().run(),
  },
  {
    label: 'Strikethrough',
    tip: 'Cross text out',
    shortcut: 'Ctrl+Shift+S',
    icon: Strikethrough,
    isActive: (e) => e.isActive('strike'),
    run: (e) => e.chain().focus().toggleStrike().run(),
  },
  {
    label: 'Inline code',
    tip: 'Format as inline code',
    shortcut: 'Ctrl+E',
    icon: Code,
    isActive: (e) => e.isActive('code'),
    run: (e) => e.chain().focus().toggleCode().run(),
  },
];

export const LIST_ACTIONS: RichTextAction[] = [
  {
    label: 'Bulleted list',
    tip: 'Start a bulleted list',
    shortcut: 'Ctrl+Shift+8',
    icon: List,
    isActive: (e) => e.isActive('bulletList'),
    run: (e) => e.chain().focus().toggleBulletList().run(),
  },
  {
    label: 'Numbered list',
    tip: 'Start a numbered list',
    shortcut: 'Ctrl+Shift+7',
    icon: ListOrdered,
    isActive: (e) => e.isActive('orderedList'),
    run: (e) => e.chain().focus().toggleOrderedList().run(),
  },
  {
    label: 'Checklist',
    tip: 'Start a checklist',
    shortcut: 'Ctrl+Shift+9',
    icon: ListChecks,
    isActive: (e) => e.isActive('taskList'),
    run: (e) => e.chain().focus().toggleTaskList().run(),
  },
];

export const BLOCK_ACTIONS: RichTextAction[] = [
  {
    label: 'Quote',
    tip: 'Format as a quote',
    shortcut: 'Ctrl+Shift+B',
    icon: Quote,
    isActive: (e) => e.isActive('blockquote'),
    run: (e) => e.chain().focus().toggleBlockquote().run(),
  },
  {
    label: 'Code block',
    tip: 'Insert a code block',
    shortcut: 'Ctrl+Alt+C',
    icon: SquareCode,
    isActive: (e) => e.isActive('codeBlock'),
    run: (e) => e.chain().focus().toggleCodeBlock().run(),
  },
];

export const BLOCK_OPTIONS: RichTextBlockOption[] = [
  { label: 'Normal text', short: 'Text', level: null },
  { label: 'Heading 1', short: 'H1', level: 1 },
  { label: 'Heading 2', short: 'H2', level: 2 },
  { label: 'Heading 3', short: 'H3', level: 3 },
];
